import s from './SendGift.module.sass';

import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Block, Button, Form, FormItem, Header, ScrollView } from '$uikit';
import { useTranslator, useUserInfo } from '$hooks';
import { giftsSelector } from '$store/gifts';
import { UserCell } from '$shared/components';
import { goBack } from '$navigation/helper';
import { formatCurrency } from '$utils';
import { CurrencyEnum } from '$store/models';
import { GiftItem } from '$core/GiftsStore/GiftItem/GiftItem';
import { balancePayActions } from '$store/balancePay';
import { BalancePayAction } from '$store/balancePay/interface';

export const SendGift: FC = () => {
  const dispatch = useDispatch();
  const { send } = useSelector(giftsSelector);
  const user = useUserInfo(send?.toId ?? 0);
  const t = useTranslator();
  const [amount, setAmount] = useState((send?.gift.price ?? 0) * 3);

  useEffect(() => {
    if (!send) {
      goBack();
    }
  }, [send]);

  const handleSend = () => {
    dispatch(
      balancePayActions.open({
        amount: amount,
        action: BalancePayAction.GIFT,
        objectId: send!.toId,
        extraId: send!.gift.id,
      }),
    );
  };

  if (!send) {
    return null;
  }

  return (
    <>
      <Header showBackButton>{t('send_gift_title')}</Header>
      <ScrollView footer={<Button onClick={handleSend}>{t('send_button')}</Button>}>
        <Form>
          <FormItem title={t('send_gift_to')}>
            <Block>
              <UserCell objectId={send.toId} isFollowBtnShown={false} disabled />
            </Block>
          </FormItem>
          <FormItem
            title={t('send_gift_donate')}
            description={t('send_gift_donate_description', {
              amount: send.gift.price,
              name: user.firstName,
            })}
          >
            <div className={s.donateAmount}>
              {formatCurrency(amount, CurrencyEnum.EUR)}
            </div>
            <input
              type="range"
              min={send.gift.price}
              max={100}
              step={1}
              value={amount + ''}
              onChange={(e) => setAmount(+e.target.value)}
            />
          </FormItem>
          <FormItem title={t('send_gift_gift')}>
            <GiftItem gift={send.gift} full onClick={() => {}} />
          </FormItem>
        </Form>
      </ScrollView>
    </>
  );
};
